import React from "react";
import PrivateRoute from "PrivateRoutes";
// import { REPORT } from "./components";
import { withRouter } from "react-router";
import { Redirect } from "react-router";
const REPORT = React.lazy(()=> import(/* webpackChunkName: "GenricReports" */'./components'));

let links = {
	"voice-report": true,
	"outbound-cdr-report": true,
	"inbound-cdr-report": true,
	"dnc-cdr-report": true,
	"agent-outbound-cdr-report": true,
	"agent-inbound-cdr-report": true,
	"agent-outbound-drop-report": true,
	"agent-inbound-missed-report": true,
	"broadcast-cdr-report": true,
	"cpaas-outbound-cdr-report": true,
	"cpaas-inbound-cdr-report": true,
	"contact-list-quality-assurance-report": true,
};

let messagingLinks = {
	"sms-report": true,
	"rcs-report": true,
	"whatsapp-report": true,
};

let matchFromGenric;

const genericReport = ({ match }) => {
	let key = match.params.type || "report";
	if (links[`${match.params.type}`] || messagingLinks[`${match.params.type}`]) {
		return <REPORT key={key} reportName={match.params.type} />;
	}
	return <Redirect to="/not-found" />;
};

const routes = () => (
	<React.Fragment>
		<PrivateRoute
			key={"/reporting/cdr"}
			exact={true}
			path="/reporting/cdr/:type"
			component={genericReport}
		/>
		<PrivateRoute
			key={"/message/cdr"}
			exact={true}
			path="/message/cdr/:type"
			component={genericReport}
		/>
	</React.Fragment>
);

export default withRouter(routes);



// WEBPACK FOOTER //
// src/modules/screens/reporting/genricVoiceCDR/routes.js